import { ARTWORK_ID_PARAM, USER_ID_PARAM } from './params'

const ARTWORK_ID = ':' + ARTWORK_ID_PARAM
const USER_ID = ':' + USER_ID_PARAM

// public routes

export const home = () => '/'

export const signIn = () => '/#signin'

export const signUp = () => '/#signup'

export const forgotPassword = () => '/#forgot-password'

export const verifyEmail = () => '#verify-email'

export const emailVerified = () => '#email-verified'

export const reset = () => '/reset'

export const verify = () => '/verify'

// private routes

export const privateRoot = () => '/app'

export const signOut = () => `${privateRoot()}/signout`

export const account = () => `${privateRoot()}/account`

export const accountEditPassword = () => `${account()}/edit-password`

export const artistHome = () => `${privateRoot()}/`

export const artworks = () => `${privateRoot()}/artworks`

export const artwork = (artworkId = ARTWORK_ID) => `${artworks()}/${artworkId}`

export const artworkEdit = (artworkId = ARTWORK_ID) =>
  `${artwork(artworkId)}/edit`

export const selectFiles = () => `${privateRoot()}/upload/select-files`

export const upload = () => `${privateRoot()}/upload`

export const sales = () => `${privateRoot()}/sales`

export const dashboard = () => `${privateRoot()}/`

export const exportArtists = () => `${privateRoot()}/export-artists`

export const exportArtworks = () => `${privateRoot()}/export-artworks`

export const exportArtwork = (artworkId = ARTWORK_ID) =>
  `${exportArtworks()}/${artworkId}`

export const exportSales = () => `${privateRoot()}/export-sales`

export const users = () => `${privateRoot()}/users`

export const user = (userId = USER_ID) => `${users()}/${userId}`

export const userEdit = (userId = USER_ID) =>
  `${user(userId)}/edit`

export const userEditPassword = (userId = USER_ID) =>
  `${user(userId)}/edit-password`



// WEBPACK FOOTER //
// ./src/routes/index.js